import angular from 'angular'
import { LeadsPolicyModule } from './policy/leads-policy.module';
import { LeadOfficeTeamModule } from './lead-office-team/lead-office-team.module';
import { LeadReportsModule } from './reports/lead-reports.module';
import { LeadsRoutingModule } from './leads-routing.module';

export const LeadsModule = angular
    .module("apex.mainApp.leads", [
        LeadOfficeTeamModule,
        LeadsPolicyModule,
        LeadReportsModule,
        LeadsRoutingModule
    ])
    .name
